import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
    <rect width={24} height={24} fill='#E0E3EB' rx={6} />
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M14.387 12A2.384 2.384 0 0 1 12 14.387 2.384 2.384 0 0 1 9.613 12 2.384 2.384 0 0 1 12 9.613 2.384 2.384 0 0 1 14.387 12'
    />
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M12 17.513c2.353 0 4.547-1.386 6.073-3.786.6-.94.6-2.52 0-3.46-1.526-2.4-3.72-3.787-6.073-3.787s-4.547 1.387-6.073 3.787c-.6.94-.6 2.52 0 3.46 1.526 2.4 3.72 3.786 6.073 3.786'
    />
  </svg>
);
export default SvgRefresh;
